<section class="section-white" *ngIf="multiCuurencyPanelData">
  <div class="section-container">
    <div class="product-blog-container">
      <ng-container>
        <div class="product-blog-row">
          <div
            class="product-blog padd-48"
            *ngFor="
              let card of multiCuurencyPanelData?.cards;
              let odd = odd;
              let i = index
            "
            [ngClass]="
              i === 0 ? 'moonstone-100' : i === 1 ? 'pink-100' : 'blue-100'
            "
          >
            <a href="{{card?.fields?.link | urlParams:queryParams}}" class="multi-curr-card-link"></a>
              <div>
                <div class="product-blog-subheading mar-b-16">
                  {{ card?.fields?.tags?.fields?.tagText }}
                  <img
                    loading="lazy"
                    [src]="card?.fields?.iconImage?.fields?.file?.url"
                    alt=""
                  />
                </div>
                <div class="product-blog-heading mar-b-16">
                  {{ card?.fields?.richTextTitle?.content[0]?.content[0]?.value }}
                </div>
                <p class="product-blog-description">
                  {{ card?.fields?.description?.content[0]?.content[0]?.value }}
                </p>
              </div>
              <figure>
                <img
                  loading="lazy"
                  src="{{ card?.fields?.imageicon?.fields?.file?.url }}"
                  class="wid-full"
                  alt=""
                />
              </figure>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
